module.exports = __webpack_public_path__ + "static/media/to.61628a71.svg";